export const ROOT = '/';
export const COMPANIES = '/companies';
export const DASHBOARD = '/dashboard';
export const OTP = '/otp';
export const USERS = '/users';
export const ALERTS = '/alerts';
export const SETTINGS = '/settings';
export const SOLUTIONS = '/solutions';
export const SITES = '/sites';
export const LOGIN_CALLBACK = '/login/callback';
export const HEALTH_CHECK = '/health-check';
export const MONITORING = '/monitoring';
export const Docs = '/help-center';
export const APP_STREAM = '/app/:appId/sessions/:sessionId';
export const APP_STREAM_REDIRECT = '/app/:appId/sessions';

// Omniverse Portal Routes
export const OMNIVERSE = '/omniverse';
export const OMNIVERSE_HOME = '/omniverse';
export const OMNIVERSE_SESSIONS = '/omniverse/sessions';
export const OMNIVERSE_APP = '/omniverse/app/:appId';
export const OMNIVERSE_APP_SESSIONS = '/omniverse/app/:appId/sessions';
export const OMNIVERSE_APP_STREAM = '/omniverse/app/:appId/sessions/:sessionId';
